import ProjectCard from "./ProjectCard";

const Projects = () => {
    const projects = 
    [
        {
            title: 'json-db 📁',
            type: 'Open Source',
            description: 'A python module that exposes a simple API for thread-safe operations on a json file serving as a database of sorts',
            stack: 'Standard python libraries with portalocker, a module that uses OS-level file locks for concurrency',
            link:'https://github.com/MAhmadW/json-db'
        },
        {
            title: 'Portfolio Website 🎨',
            type: 'Personal',
            description: 'The website that you are currently browsing. The purpose it serves is to showcase my projects and deployments (And to give me bragging rights 👀)',
            stack: 'The frontend is built with ReactJS and styled using Tailwind. Currently it does not have a backend, but I might build one based on need. Deployed to Railway with NPM\'s serve package.',
            link:'https://ahmad-waseem-portfolio.up.railway.app/'
        },
        {
            title: 'Ambient Dashboard 🌡️',
            type: 'Personal',
            description: 'A microcontroller monitoring my room\'s ambient temperature, humidity, and light communicates with a web server that also monitors for erratic values. A web dashboard displays the records and alarm state',
            stack: 'FastAPI with Jinja2 templates for the dashboard. Arduino and ESP32 for the real-time sensing',
            link:'https://ambient-dashboard-production.up.railway.app/'
        },
        {
            title: 'Kollegio AI Website 📜',
            type: 'Professional',
            description: 'This is the website for the startup I currently work at. Stay tuned for announcements on social media for our launch!',
            stack: 'I work with ReactTS, ExpressTS, FastAPI and python libraries such as Selenium and BeautifulSoup for data.',
            link:'https://www.kollegio.ai/'
        },
    ]
    return (
        <div className=" w-full flex flex-col flex-wrap mx-auto items-center justify-center">
            {projects.map((project)=>{
                return (
                    <ProjectCard project={project}/>
                )
            })}
            
        </div>
    )
};

export default Projects;